<app-website-header></app-website-header>
<div class="header">
    <img src="../../../../../assets/images/webinars-website.jpg" width="100%" height="auto" />
    <div class="header-name">
        <p style="font-family: 'Libre Baskerville' !important;">Webinars</p>
    </div>
</div>
<div style="background-color: #F5F5F5;" >

    <div class="upcoming p-5">
        <div class="data d-flex gap-2 sm-data">
            <div class="d-flex align-items-center justify-content-center " >
                <img src="../../assets/images/icons/webinar-icon.svg" class = "upcoming-webinar-img">
            </div>
            <h2 class="-webinars" style="font-weight: bolder;font-size:12; font-family: 'Georgia' !important; ">Upcoming Webinars</h2>
        </div>
        <div class="webinar-block d-flex flex-column d-sm-flex flex-sm-row ">
            <div class="row order-1 order-sm-0 webinar-container" >

                <!-- UpComing Webinars -->
                <div class="col-md-4 webinar-card " *ngFor="let webinar of upcomingWebinars.slice(0, 6)">
                    <div class="d-flex card my-2" style="border: 1px solid #F5F5F5; box-shadow: 0px 4px 16px 0px #0000000D;" (click)="view(webinar.id, webinar?.sponsored)" >
                        <div class="card-img">
                            <div class="sponsored_tag" *ngIf="webinar?.sponsored"><img src="../../../assets/images/ph_seal-check-fill.svg" alt="">Sponsored</div>
                            <img [src]="webinar.image" width="100%" height="130px" class="img-radius">
                        </div>
                        <div class="card-heading elipses">
                            <p class="card-title-heading" > {{ webinar.webinarTitle | truncateText: originalTruncateText  }} </p>
                        </div>
                        <div class="card-info">
                            <div class="card-info-calender d-flex">
                                <img src="../../../assets/images/icons/calender-icon-blue.svg" style="padding: 0px 5px;">
                                <div class="d-flex flex-column justify-content-around">
                                    <p class="date-time">
                                        {{ (webinar?.webinarDate && webinar?.webinarTime) ? (webinar?.webinarDate + ' ' + webinar?.webinarTime) : 
                                           (webinar?.webinarDate ? webinar?.webinarDate : 'Will be announced soon') }}
                                    </p>
                                </div>
                            </div>
                            <div class="card-info-person d-flex ">
                                <img [src]="webinar.hostImage" class="card-info-person-logo" width="100%" height="auto" style="max-width: 32px; border-radius: 50%;" />
                                <div class="elipses">
                                    <p class="person-name elipses"> {{webinar.speakersName[0] | truncateText: 29}} <span *ngIf="webinar.speakersName.length > 1" >...</span> </p>
                                    <p class="specialization specialityName m-0"> {{ webinar.speciality }} </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 webinar-card" *ngFor="let webinar of upcomingWebinars.slice(6, upcomingWebinars.length)">
                    <div *ngIf="!viewMoreUpcomingToggle" class="d-flex card my-2" style="border: 1px solid #F5F5F5; box-shadow: 0px 4px 16px 0px #0000000D;" (click)="view(webinar.id, webinar?.sponsored)" >
                        <div class="card-img">
                            <div class="sponsored_tag" *ngIf="webinar?.sponsored"><img src="../../../assets/images/ph_seal-check-fill.svg" alt="">Sponsored</div>
                            <img [src]="webinar.image" width="100%" height="130px" class="img-radius">
                        </div>
                        <div class="card-heading elipses">
                            <p class="card-title-heading" > {{ webinar.webinarTitle | truncateText: originalTruncateText }} </p>
                        </div>
                        <div class="card-info">
                            <div class="card-info-calender d-flex">
                                <img src="../../../assets/images/icons/calender-icon-blue.svg" style="padding: 0px 5px;">
                                <div class="d-flex flex-column justify-content-around">
                                    <p class="date-time">
                                        {{ (webinar?.webinarDate && webinar?.webinarTime) ? (webinar?.webinarDate + ' ' + webinar?.webinarTime) : 
                                           (webinar?.webinarDate ? webinar?.webinarDate : 'Will be announced soon') }}
                                    </p>                              
                                </div>
                            </div>
                            <div class="card-info-person d-flex ">
                                <img [src]="webinar.hostImage" class="card-info-person-logo" width="100%" height="auto" style="max-width: 32px;" />
                                <div class="elipses">
                                    <p class="person-name elipses"> {{webinar.speakersName[0] | truncateText: 29}} <span *ngIf="webinar.speakersName.length > 1" >...</span> </p>
                                    <p class="specialization specialityName m-0"> {{ webinar.speciality }} </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end pointer m-2" *ngIf="upcomingWebinars.length > 6" 
     (click)="toggleView('upcoming')">
  <button class="view-more button-primary button-tab-view btn mx-3" style="background-color:#0D87C8;color:white">
    {{ viewMoreUpcomingToggle ? 'View More' : 'View Less' }}
  </button>
</div>
                <div *ngIf="upcomingWebinars.length === 0 && !loading"  class="no-results">
                    <img src="../../../../assets/images/Empty bin.png" alt="no-records-found" class="no-results-image">
                    <div class="no-records-found"> No Webinars Found </div>
                  </div>
              
            </div>
            <div class="filters" >
                <div class="f-specialties">
                    <p *ngIf="!isMobileView" class="card-heading data" (click)="dropdown('specialties')" >Filter by Specialties
                        <img
                        [src]="isSpecialtiesOpen ? 'assets/images/up-arrow-icon.svg' : 'assets/images/down-arrow-icon.svg'"

                      />
                    </p>
                    <p *ngIf="isMobileView" class="card-heading data"  (click)="dropdown('specialties')" >
                      Filter by Specialties
                      <img
                        [src]="isSpecialtiesOpen ? 'assets/images/up-arrow-icon.svg' : 'assets/images/down-arrow-icon.svg'"

                      />
                    </p>
                    <ng-container *ngIf="isSpecialtiesOpen">
                        <div style="max-height: 150px; overflow: scroll;" class="scrollingBarView">
                            <ul *ngFor="let specialty of specialties.slice(0, size.specialitiesU)" class="m-0 p-0"  >
                                <li>
                                    <mat-checkbox (change)="specialtySelected($event, specialty, 'specialty')"> {{specialty}} </mat-checkbox>
                                </li>
                            </ul>
                        </div>
                        <div class="view-all-div d-flex flex-row gap-1 " style="display: flex; justify-content: flex-end;" *ngIf="size.specialitiesU === 3">
                            <img src="../../../assets/images/icons/view-all-arrow-icon.svg" class="d-flex align-items-center justify-content-center" />
                            <span class="view-all d-flex align-items-center justify-content-center " style="margin-right: 29px;" (click)="specialtiesViewAll('upcoming', true)" >View all</span>
                        </div>
                        <div class="view-all-div d-flex flex-row gap-1 " style="display: flex; justify-content: flex-end;" *ngIf="size.specialitiesU !== 3">
                            <img src="../../../assets/images/icons/view-all-arrow-icon.svg" class="d-flex align-items-center justify-content-center" />
                            <span class="view-all d-flex align-items-center justify-content-center " style="margin-right: 29px;" (click)="specialtiesViewAll('upcoming', false)" >View less</span>
                        </div>
                    </ng-container>
                </div><br>





                    <div class="f-sponsors">
                        <p *ngIf="!isMobileView" class="card-heading data" (click)="dropdown('sponsors')">Filter by Sponsors
                            <img
                            [src]="isSponsorsOpen ? 'assets/images/up-arrow-icon.svg' : 'assets/images/down-arrow-icon.svg'"

                        />
                        </p>
                        <p *ngIf="isMobileView" class="card-heading data" (click)="dropdown('sponsors')">
                        Filter by Sponsors
                        <img
                            [src]="isSponsorsOpen ? 'assets/images/up-arrow-icon.svg' : 'assets/images/down-arrow-icon.svg'"

                        />
                        </p>
                        <ng-container *ngIf="isSponsorsOpen">
                        <div style="max-height: 150px; overflow: scroll;" class="scrollingBarView" >
                            <ul *ngFor="let sponsor of sponsors.slice(0, size.sponsorsU)" class="m-0 p-0">
                            <li>
                                <mat-checkbox (change)="sponsorSelected($event, sponsor, 'specialty')"> {{sponsor}} </mat-checkbox>
                            </li>
                            </ul>
                        </div>
                            <div class="view-all-div d-flex flex-row gap-1  " style="display: flex; justify-content: flex-end;" *ngIf="size.sponsorsU === 3">
                                <img src="../../../assets/images/icons/view-all-arrow-icon.svg" class="d-flex align-items-center justify-content-center" />
                                <span class="view-all d-flex align-items-center justify-content-center " style="margin-right: 29px;" (click)="sponsorsViewAll('upcoming', true)" >View all</span>
                            </div>
                            <div class="view-all-div d-flex flex-row gap-1  " style="display: flex; justify-content: flex-end;" *ngIf="size.sponsorsU !== 3">
                                <img src="../../../assets/images/icons/view-all-arrow-icon.svg" class="d-flex align-items-center justify-content-center" />
                                <span class="view-all d-flex align-items-center justify-content-center " style="margin-right: 29px;" (click)="sponsorsViewAll('upcoming', false)" >View less</span>
                            </div>
                       </ng-container>
                    </div><br>
                    <div class="f-doctors" >
                        <p *ngIf="!isMobileView" class="card-heading data" (click)="dropdown('doctors')">Filter by Doctors
                            <img
                            [src]="isDoctorsOpen ? 'assets/images/up-arrow-icon.svg' : 'assets/images/down-arrow-icon.svg'"

                        />
                        </p>
                        <p *ngIf="isMobileView" class="card-heading data"  (click)="dropdown('doctors')" >
                        Filter by Doctors
                        <img
                            [src]="isDoctorsOpen ? 'assets/images/up-arrow-icon.svg' : 'assets/images/down-arrow-icon.svg'"

                        />
                        </p>
                        <ng-container *ngIf="isDoctorsOpen">
                            <div  style="max-height: 150px; overflow: scroll;" class="scrollingBarView"  >
                                <ul *ngFor="let doctor of doctors.slice(0, size.doctorsU)" class="m-0 p-0">
                                <li>
                                    <mat-checkbox (change)="doctorSelected($event, doctor, 'upcoming')"> {{doctor}} </mat-checkbox>
                                </li>
                                </ul>
                                <div *ngIf="doctorViewAll===1">
                                    <ul *ngFor="let doctor of doctors.slice(0, doctors.length)" class="m-0 p-0">
                                        <li>
                                            <mat-checkbox (change)="doctorSelected($event, doctor, 'upcoming')"> {{doctor}} </mat-checkbox>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="view-all-div d-flex flex-row gap-1  " style="display: flex; justify-content: flex-end;"  *ngIf="size.doctorsU === 3">
                                <img src="../../../assets/images/icons/view-all-arrow-icon.svg" class="d-flex align-items-center justify-content-center" />
                                <span class="view-all d-flex align-items-center justify-content-center " style="margin-right: 29px;" (click)="doctorsViewAll('upcoming', true)" >View all</span>
                            </div>
                            <div class="view-all-div d-flex flex-row gap-1  " style="display: flex; justify-content: flex-end;"  *ngIf="size.doctorsU !== 3">
                                <img src="../../../assets/images/icons/view-all-arrow-icon.svg" class="d-flex align-items-center justify-content-center" />
                                <span class="view-all d-flex align-items-center justify-content-center " style="margin-right: 29px;" (click)="doctorsViewAll('upcoming', false)" >View less</span>
                            </div>
                        </ng-container>
                    </div><br>


            </div>
        </div>
    </div>



    <div class="Archived px-5">
        <div class="data d-flex gap-2 sm-data">
            <div class="d-flex align-items-center justify-content-center " >
                <img src="./../../../assets/images/icons/archieved-webinars.svg" class = "upcoming-webinar-img" >
            </div>
            <h2 class="-webinars" style="font-weight: bolder;font-size:12; font-family: 'Georgia' !important; ">Archived Webinars</h2>
        </div>
        <div class="webinar-block d-flex flex-column d-sm-flex flex-sm-row">
            <div class="row order-1 order-sm-0 webinar-container" >
              
                <div class="col-md-4 webinar-card " *ngFor="let webinar of archivedWebinars.slice(0, archivedLength)">
                    <div class="d-flex card my-2" style="border: 1px solid #F5F5F5; box-shadow: 0px 4px 16px 0px #0000000D;" (click)="view(webinar.id, webinar?.sponsored)" >
                        <div class="card-img">
                            <div class="sponsored_tag" *ngIf="webinar?.sponsored"><img src="../../../assets/images/ph_seal-check-fill.svg" alt="">Sponsored</div>
                            <img [src]="webinar.image" width="100%" height="130px" class="img-radius">
                        </div>
                        <div class="card-heading elipses">
                            <p class="card-title-heading" > {{ webinar.webinarTitle | truncateText: originalTruncateText  }} </p>
                        </div>
                        <div class="card-info">
                            <div class="card-info-calender d-flex">
                                <img src="../../../assets/images/icons/calender-icon-blue.svg" style="padding: 0px 5px;">
                                <div class="d-flex flex-column justify-content-around">
                                    <p class="date-time"> {{ webinar.webinarDate }} {{ webinar.webinarTime }} </p>
                                </div>
                            </div>
                            <div class="card-info-person d-flex ">
                                <img [src]="webinar.hostImage" class="card-info-person-logo" width="100%" height="auto" style="max-width: 32px;border-radius: 50%; " />
                                <div class="d-flex flex-column justify-content-around elipses">
                                    <p class="person-name"> {{webinar.speakersName[0]}} </p>
                                    <p class="specialization specialityName m-0"> {{ webinar.speciality }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end pointer m-2" 
                *ngIf="archivedWebinars.length > 6" 
                (click)="toggleView('archived')">
             <button class="view-more button-primary btn  mx-3 button-tab-view" style="background-color:#0D87C8;color:white">
               {{ viewMoreArchivedToggle ? 'View More' : 'View Less' }}
             </button>
           </div>
                <div *ngIf="archivedWebinars.length === 0 && !loading"  class="no-results">
                    <img src="../../../../assets/images/Empty bin.png" alt="no-records-found" class="no-results-image">
                    <div class="no-records-found"> No Webinars Found </div>
                  </div>
            </div>    
          

            <div class="filters">
                <div class="f-specialties">
                    <p *ngIf="!isMobileView" class="card-heading data" (click)="dropdownArchived('specialties')" >Filter by Specialties
                        <img
                        [src]="isSpecialtiesOpenArchived ? 'assets/images/up-arrow-icon.svg' : 'assets/images/down-arrow-icon.svg'"

                      />
                    </p>

                    <p *ngIf="isMobileView" class="card-heading data" (click)="dropdownArchived('specialties')">
                      Filter by Specialties
                      <img
                        [src]="isSpecialtiesOpenArchived ? 'assets/images/up-arrow-icon.svg' : 'assets/images/down-arrow-icon.svg'"

                      />
                    </p>
                    <ng-container *ngIf="isSpecialtiesOpenArchived">
                    <div style="max-height: 150px; overflow: scroll;" class="scrollingBarView" >
                        <ul *ngFor="let specialty of specialties.slice(0, size.specialitiesA)" class="m-0 p-0"  >
                            <li>
                                <mat-checkbox (change)="specialtySelected($event, specialty, 'archived')"> {{specialty}} </mat-checkbox>
                            </li>
                        </ul>
                    </div>
                    <div class="view-all-div d-flex flex-row gap-1 " style="display: flex; justify-content: flex-end;" *ngIf="size.specialitiesA === 3">
                        <img src="../../../assets/images/icons/view-all-arrow-icon.svg" class="d-flex align-items-center justify-content-center" />
                        <span class="view-all d-flex align-items-center justify-content-center " style="margin-right: 29px;" (click)="specialtiesViewAll('archived', true)" >View all</span>
                    </div>
                    <div class="view-all-div d-flex flex-row gap-1 " style="display: flex; justify-content: flex-end;" *ngIf="size.specialitiesA !== 3">
                        <img src="../../../assets/images/icons/view-all-arrow-icon.svg" class="d-flex align-items-center justify-content-center" />
                        <span class="view-all d-flex align-items-center justify-content-center " style="margin-right: 29px;" (click)="specialtiesViewAll('archived', false)" >View less</span>
                    </div>
                    </ng-container>
                </div><br>
                <div class="f-sponsors">
                    <p *ngIf="!isMobileView" class="card-heading data"  (click)="dropdownArchived('sponsors')">Filter by Sponsors
                        <img
                        [src]="isSponsorsOpenArchived ? 'assets/images/up-arrow-icon.svg' : 'assets/images/down-arrow-icon.svg'"

                    />
                    </p>

                    <p *ngIf="isMobileView" class="card-heading data"  (click)="dropdownArchived('sponsors')">
                    Filter by Sponsors
                    <img
                        [src]="isSponsorsOpenArchived ? 'assets/images/up-arrow-icon.svg' : 'assets/images/down-arrow-icon.svg'"

                    />
                    </p>
                    <ng-container *ngIf="isSponsorsOpenArchived">
                    <div style="max-height: 150px; overflow: scroll;" class="scrollingBarView" >
                        <ul *ngFor="let sponsor of sponsors.slice(0, size.sponsorsA)" class="m-0 p-0">
                        <li>
                                <mat-checkbox (change)="sponsorSelected($event, sponsor, 'archived')"> {{sponsor}} </mat-checkbox>
                        </li>
                        </ul>
                    </div>
                    <div class="view-all-div d-flex flex-row gap-1  " style="display: flex; justify-content: flex-end;" *ngIf="size.sponsorsA === 3">
                        <img src="../../../assets/images/icons/view-all-arrow-icon.svg" class="d-flex align-items-center justify-content-center" />
                        <span class="view-all d-flex align-items-center justify-content-center " style="margin-right: 29px;" (click)="sponsorsViewAll('archived', true)" >View all</span>
                    </div>
                    <div class="view-all-div d-flex flex-row gap-1  " style="display: flex; justify-content: flex-end;" *ngIf="size.sponsorsA !== 3">
                        <img src="../../../assets/images/icons/view-all-arrow-icon.svg" class="d-flex align-items-center justify-content-center" />
                        <span class="view-all d-flex align-items-center justify-content-center " style="margin-right: 29px;" (click)="sponsorsViewAll('archived', false)" >View less</span>
                    </div>
                    </ng-container>
                </div><br>
                <div class="f-doctors">
                    <p *ngIf="!isMobileView" class="card-heading data"  (click)="dropdownArchived('doctors')" >Filter by Doctors
                        <img
                        [src]="isDoctorsOpenArchived ? 'assets/images/up-arrow-icon.svg' : 'assets/images/down-arrow-icon.svg'"

                    />
                    </p>
                        <p *ngIf="isMobileView" class="card-heading data" (click)="dropdownArchived('doctors')" >
                        Filter by Doctors
                        <img
                            [src]="isDoctorsOpenArchived ? 'assets/images/up-arrow-icon.svg' : 'assets/images/down-arrow-icon.svg'"

                        />
                        </p>
                        <ng-container *ngIf="isDoctorsOpenArchived">
                    <div style="max-height: 150px; overflow: scroll;" class="scrollingBarView" >
                        <ul *ngFor="let doctor of doctors.slice(0, size.doctorsA)" class="m-0 p-0">
                        <li>
                                <mat-checkbox (change)="doctorSelected($event, doctor, 'archived')"> {{doctor}} </mat-checkbox>
                        </li>
                        </ul>
                    </div>
                    <div class="view-all-div d-flex flex-row gap-1  " style="display: flex; justify-content: flex-end;" *ngIf="size.doctorsA === 3">
                        <img src="../../../assets/images/icons/view-all-arrow-icon.svg" class="d-flex align-items-center justify-content-center" />
                        <span class="view-all d-flex align-items-center justify-content-center " style="margin-right: 29px;" (click)="doctorsViewAll('archived', true)" >View all</span>
                    </div>
                    <div class="view-all-div d-flex flex-row gap-1  " style="display: flex; justify-content: flex-end;" *ngIf="size.doctorsA !== 3">
                        <img src="../../../assets/images/icons/view-all-arrow-icon.svg" class="d-flex align-items-center justify-content-center" />
                        <span class="view-all d-flex align-items-center justify-content-center " style="margin-right: 29px;" (click)="doctorsViewAll('archived', false)" >View less</span>
                    </div>
                    </ng-container>
                </div><br>
            </div>
        </div>
    </div><br><br>
</div>
<app-website-footer></app-website-footer>
